import { useState } from 'react';
import "../Styles/style.css"
import Socials from './socialMediaBar.js';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
  Window,
    Frame,
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';
const Header = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
    return (
          <ThemeProvider theme={rose}>
            <AppBar style={{position: 'relative', display: 'flex'}}>
              <Toolbar style={{ justifyContent: 'space-between', flexWrap: 'wrap',}}>
                <div style={{ position: 'relative', display: 'flex', flexDirection: 'row', gap: '4px',}}>
                  <Button onClick={() => handleRedirect('/')} style={{ fontWeight: 'bold' }}>
                    <img
                    src='./images/winbows.png'
                    alt='react95 logo'
                    style={{ height: '20px', marginRight: 4 }}
                    />
                    Start
                  </Button>
                  
                  <Socials/>
                </div>
              
                <Frame id="lastUpdated" variant='well' style={{ width: '20%', minWidth: '200px', flexShrink: 1,}}>
                This website was last updated on {new Date(process.env.REACT_APP_BUILD_TIME).toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZoneName: 'short'
                  })}
                </Frame>
              </Toolbar>
            </AppBar>
          </ThemeProvider>
  );
}

export default Header;
